import "./OrderDisplay.css";
import { ParticipantTransactions } from "../../../Interfaces/Orders";
import {
  convertToTitleCase,
  formatCurrency,
  replaceCharacterWithSpace,
} from "../../../CommonFunctions";

interface OrderDisplayProps {
  participant_orders: ParticipantTransactions;
}

const OrderDisplay: React.FC<OrderDisplayProps> = ({ participant_orders }) => {
  const orders = participant_orders.transactions;
  const getStatusClass = (status: string) => {
    switch (status.toLowerCase()) {
      case "fulfilled":
      case "completed":
        return "participant-dashboard-order-display-status-fulfilled";

      case "processing":
        return "participant-dashboard-order-display-status-pending";

      case "cancelled":
      case "failed":
        return "participant-dashboard-order-display-status-cancelled";

      default:
        return "";
    }
  };

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className="participant-dashboard-order-display-container">
      <div className="participant-dashboard-order-display-header">
        <div>
          <h2 className="participant-dashboard-order-display-title">
            Customer Orders
          </h2>
        </div>
      </div>

      <div className="participant-dashboard-order-display-table-wrapper">
        <table className="participant-dashboard-order-display-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Transaction Type</th>
              <th>Order Type</th>
              <th>Items</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {orders.map((order, index) => (
              <tr key={index}>
                <td>
                  <p className="participant-dashboard-order-display-customer-name">
                    {order.customer_name}
                  </p>
                </td>

                <td className="participant-dashboard-order-display-items">
                  {order.transaction_type.toUpperCase()}
                </td>

                <td>
                  <span className="participant-dashboard-order-display-order-type">
                    {convertToTitleCase(
                      replaceCharacterWithSpace(order.shipping_type, "_"),
                    )}
                  </span>
                </td>

                <td className="participant-dashboard-order-display-items">
                  {order.item_count} item
                  {order.item_count !== 1 ? "s" : ""}
                </td>

                <td className="participant-dashboard-order-display-amount">
                  {formatCurrency(order.amount)}
                </td>

                <td>
                  <span
                    className={`participant-dashboard-order-display-status ${getStatusClass(
                      order.order_status,
                    )}`}
                  >
                    {order.order_status}
                  </span>
                </td>

                <td className="participant-dashboard-order-display-time">
                  {formatDate(order.created_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderDisplay;
